import { Component, OnInit } from '@angular/core';
import { BaseIndexPageComponent } from '../../../components/pages/base-index-page/base-index-page.component';
import BaseIndexPageConfig from '../../../components/pages/base-index-page/base-index-page.config';
import { DataTableColumnActions } from '../../../components/widgets/data-table/columns/data-table-column-actions/data-table-column-actions.config';
import { DataTableColumnText } from '../../../components/widgets/data-table/columns/data-table-column-text/data-table-column-text.config';
import ApiOptionsConfig from '../../../services/api/api-options.config';
import { RequestsService } from '../../../services/api/requests.service';
import { RouteService } from '../../../services/route.service';
import { DataTableColumnIcon } from '../../../components/widgets/data-table/columns/data-table-column-icon/data-table-column-icon.config';
import { DataTableColumnWaitingTime } from '../../../components/widgets/data-table/columns/data-table-column-waiting-time/data-table-column-waiting-time.config';
import { MainLayoutService } from '../../../services/main-layout.service';
import { AccessControlService } from '../../../services/access-control.service';
import { ProfileCode } from '../../../layouts/main-layout/components/sidebar/config/access-control.config';

@Component({
  selector: 'app-requests-index-page',
  imports: [BaseIndexPageComponent],
  templateUrl: './requests-index-page.component.html',
  styleUrl: './requests-index-page.component.scss'
})
export class RequestsIndexPageComponent implements OnInit {
  list: any[] = [];

  baseIndexPageConfig: BaseIndexPageConfig;

  private readonly allowedProfiles: ProfileCode[] = ['ADM1', 'SAL1', 'SAL2', 'SAL3'];

  constructor(
    protected requestsService: RequestsService,
    private routeService: RouteService,
    private mainLayoutService: MainLayoutService,
    private accessControlService: AccessControlService
  ) {
    this.baseIndexPageConfig = {
      pageTitle: 'Requests',
      cardTitle: 'Requests',
      dataTable: {
        data: [],
        searchModel: {
          userId: null,
          firstName: null,
          lastName: null,
        },
        topInputFilters: [
          {
            label: 'Date From',
            attribute: 'requestTimeStart',
            type: 'date'
          },
          {
            label: 'Date To',
            attribute: 'requestTimeEnd',
            type: 'date'
          }
        ],
        pagination: null,
        columns: [
          new DataTableColumnText({
            attribute: 'requestsTime',
            header: 'Requests Time',
            value: (item: any) => {
              return item?.createTime;
            }
          }),
          new DataTableColumnIcon({
            attribute: 'source',
            header: 'Source',
            filter: 'select',
            filterOptionsSource: 'source',
            value: (item: any) => {
              return item?.source;
            }
          }),
          new DataTableColumnText({
            attribute: 'companyName',
            header: 'Company',
            filter: 'text',
            value: (item: any) => {
              return item.customer.companyName;
            }
          }),
            new DataTableColumnText({
            attribute: 'brand',
            header: 'Brand',
            filter: 'text',
            value: (item: any) => {
              return item.customer.brand;
            }
          }),
          new DataTableColumnText({
            attribute: 'code',
            header: 'Code',
            filter: 'text',
            value: (item: any) => {
              return item?.code;
            }
          }),
          new DataTableColumnText({
            attribute: 'customerTypeId',
            header: 'Type',
            filter: 'select',
            filterOptionsSource: 'clientTypes',
            value: (item: any) => {
              return item.customerType.name;
            }
          }),        
          new DataTableColumnText({
            attribute: 'assignee',
            header: 'Assignee',
            filter: 'text',
            value: (item: any) => {
              return item?.takingCareUser ? item.takingCareUser.firstName + ' ' + item.takingCareUser.lastName : '';
            }
          }),
          new DataTableColumnText({
            attribute: 'summary',
            header: 'Summary',
            filter: 'text',
            value: (item: any) => {
              return item?.summary;
            }
          }),
          new DataTableColumnWaitingTime({
            attribute: 'waitingTime',
            header: 'Waiting Time',
            value: (item: any) => {
              return item?.alarm;
            }
          }),
          new DataTableColumnText({
            attribute: 'status',
            header: 'Status',
            filter: 'select',
            filterOptionsSource:'requestStatus',
            value: (item: any) => {
              return item?.status ?? '';
            }
          }),
          new DataTableColumnActions({
            header: 'Actions',
            attribute: 'actions',
            style: { width: '50px' },
            buttons: [
              {
                icon: 'fa-eye',
                tooltip: 'View request details',
                onClick: (item: any) => {
                  this.routeService.requestsDetail(item.requestId)
                }
              },
              {
                icon: 'fa-edit',
                tooltip: 'Edit request',
                onClick: (item: any) => {
                  this.routeService.requestsUpdate(item.requestId)
                }
              },
              {
                icon: 'fa-trash',
                tooltip: 'Delete request',
                onClick: (item: any) => {
                },
                isDelete: true
              },

            ]
          })
        ]
      },
      apiListService: (options: ApiOptionsConfig) => this.requestsService.list(options),
      responseListModelName: 'requests',
    }
  }

  ngOnInit(): void {
    this.mainLayoutService.activeProfile$.subscribe(profileCode => {
      if (profileCode && this.allowedProfiles.includes(profileCode as ProfileCode)) {
        this.baseIndexPageConfig.addNewItemButton = {
          type: 'success',
          title: 'New Request',
          onClick: () => {
            this.routeService.requestsCreate();
          }
        };
      } else {
        this.baseIndexPageConfig.addNewItemButton = undefined;
      }
    });
  }
}
